import AdditionalRequirement from "../../AdditionalRequirement";

export default class SelfToSelfLimitResult {
    constructor(jsonResponse) {

        this.idType = jsonResponse["id-type"];
        this.dailyLimitExceeded = jsonResponse["daily-limit-exceeded"];
        this.monthlyLimitExceeded = jsonResponse["monthly-limit-exceeded"];
        this.canContinue = jsonResponse["can-continue"];
        this.hasAdditionalRequirements = jsonResponse["has-additional-requirements"];

        let additionalRequirementsJson = jsonResponse["additional-requirements"] || [];
        this.additionalRequirements = [];
        additionalRequirementsJson.forEach(singleAdditionalRequirementJson => {
            this.additionalRequirements.push(new AdditionalRequirement(singleAdditionalRequirementJson));
        })

    }
}
